import React from "react";
import api from "../../services/api";
import img from "../../assets/Foto.png"
import {useState, useEffect} from 'react';
import {useParams}  from 'react-router-dom';
import "./listaexecucao.css";
import {HStack} from "@chakra-ui/react";


function ListaExecucao(props){
  
    let [dados,setdados] = useState([])
    let [qtde,setQtde] = useState(0)

    const parametros = useParams(); 
    const [OS, setOS] = useState('');
    const [data, setData] = useState('');
    const [Horario, setHorario] = useState('');
    const [NomeAtendimento, setNomeAtendimento] = useState('');
    const [observacao, setObservacao] = useState('');
    
    async function CarregaDocto()
    {
 
        const resultado = await api.get('/lstExec/?os=' + parametros.NumOrdem);
        
        setdados(resultado.data)   
        setQtde(resultado.data[0].IdUpl) 

        setOS(resultado.data[0].NumOrdem)
        setData(resultado.data[0].Data)
        setHorario(resultado.data[0].Horario)
        setNomeAtendimento(resultado.data[0].NomeAtendimento)
        setObservacao(resultado.data[0].Observacao)

    }

    useEffect(()=>{
          CarregaDocto()
    },[]  );

   return<>
                { qtde === 0 ?
               
                    <div className="msgEmpty" role="alert">
                            Nenhum item a ser exibido !
                    </div>
                  :    
                  <div className="offset-lg-1 col-lg-10 mt-0">
                  <form > 
                           <div className='container' >    
                                     <HStack spacing="4">
                                           <div >
                                               <label htmlFor="exampleInputEmail1" className="form-label">Nº O.S.</label>
                                               <div className="EdtId"> <span className='lbl badge rounded-pill bg-primary ms3'>{parametros.NumOrdem}</span> </div>
                                           </div>  
                                           <div >
                                               <label htmlFor="exampleInputEmail1" className="form-label">Data</label>
                                               <div> 
                                                   <input className='DtExec' type="text" name = 'Data' onChange={(e) => setData(e.target.value)} value={data}  ></input> 
                                               </div>
                                           </div>   
                                           <div >
                                                <label htmlFor="exampleInputEmail1" className="form-label">Horário </label>
                                                <div >
                                                   <input name = 'nome' onChange={(e) => setHorario(e.target.value)} value={Horario} type="text"  className="HrExec" id="nome" aria-describedby="emailHelp" />
                                               </div>
                                           </div> 
                                           <div >
                                               <label htmlFor="exampleInputEmail1" className="form-label">Tipo de Atendimento </label>
                                               <div> 
                                                   <input name = 'fantasia' onChange={(e) => setNomeAtendimento(e.target.value)} value={NomeAtendimento} type="text" className="NmAtend" id="fantasia" aria-describedby="emailHelp" />
                                               </div>
                                           </div>
                                           
                                   </HStack>
                                   
                                   <div>
                                          <div className="mb-3">
                                               <label htmlFor="exampleInputEmail1" className="form-label">Observação</label>
                                               <br></br>                             
                                               <textarea id="observacao" name="observacao" rows="2" cols="150"   onChange={(e) => setObservacao(e.target.value)}  value={observacao} type="text"/>
                                           </div>
                                   </div>
                              </div>      
                  </form>
         </div>          
                    
             }

</>

}

export default ListaExecucao;
